import React, {Component} from 'react';
import {connect} from 'react-redux';
// utils
import {formApiUrl,Translations} from '../../../../../utils';
// constant
import {FORM_REFS} from '../../../../../constants';
// restClient
import {eapiClient, aemHostClient} from '../../../../../restClient';
// children
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
//action Creator
import {setCurrentProductGlsCashCon} from '../../../actions/actionCreator';
import {blockUi, unBlockUi} from '../../../../../actions/actionCreator';

//style
import './AddOtherAccount.css';

class CreateNewCashconOtherAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unqiueBankName:[
        {
          name:'HSBC',
          value:'hsbc'
        }
      ]
    };
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_gls-add-other-account-hsbc-cc";
     if(this.props.mode === "edit") {
      apiURL = apiURL.replace("json_gls-add-", "json_gls-edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({formJson: data});
    });
}
  getFormData = (formData) => {
    let _formData ={
     ...formData,
     bankName:formData.bankName !== undefined ? formData.bankName.value !== 'hsbc' ? formData.bankName.value === 'other' ? formData.otherBankName !== undefined ? formData.otherBankName : "HSBC" : formData.bankName.name :"HSBC" :"",
     hsbcAccount:formData.bankName !== undefined ? formData.bankName.value === 'hsbc' ? 'hsbc': undefined:undefined
    }
    this.setState({formData:_formData});
  }


componentDidMount(){
  let key = window.sessionStorage.getItem("getCurrentDropDown") !== null ? window.sessionStorage.getItem("getCurrentDropDown") : this.props.history.location.state.key ;

  if(key !== 'masterAccount'){
    let _caseId = Object.keys(this.props.cases)[0];
    let url = `${'/product/other/accounts/'}${_caseId}${'/country/bankNames'}`
    let _unqiueBankName =[...this.state.unqiueBankName];
    eapiClient(url)
    .then(({data})=>{
      _unqiueBankName.push(...data.responseData)
      let obj= {
        name:'Other',
        value:'other'
      }
      _unqiueBankName.push(obj)
      this.setState({
          unqiueBankName: _unqiueBankName
        })
      })
    }
}

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
    var {productId} = this.props.match.params;
    var requestData = {...this.state.formData};

    if(this.props.mode === 'edit') {
      apiURL = this.translations(apiURL) + "/" + this.state.formData.id;
    }else {
      apiURL =  this.translations(apiURL)
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(formApiUrl(apiURL, ":glsId", productId), {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data}) => {
      var key = window.sessionStorage.getItem("getCurrentDropDown");
      this.props.setCurrentProductGlsCashCon({...data.responseData});
      window.sessionStorage.setItem('key'+ key, data.responseData.otherAccounts[data.responseData.otherAccounts.length-1].id);
      this.props.history.goBack();
      this.props.unBlockUi();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    let bankDataFilter = []
    const savedPageStateString = window.sessionStorage.getItem("previousPageState");
    const savedPageState = savedPageStateString ? JSON.parse(savedPageStateString) :''

    // if(this.props.currentOtherAccount !== undefined) {
    //   formData = {...this.props.currentOtherAccount};
    // }else {
    //   formData = {hsbcAccount: 'hsbc'};
    // }
    if(this.props.currentOtherAccount !== undefined) {
      formData = {
        ...this.props.currentOtherAccount,
        bankName:{
          name:this.props.currentOtherAccount.bankName,
          value:this.props.currentOtherAccount.bankName
        }
      };

    }else {
      formData = { };
    }

    const properties = {
      accountId: this.props.match.params.accountId,
      formData,
      editType: 'create-new-cashcon-other-account',
      pathname: this.props.history.location.pathname,
      setCurrency: savedPageState.sweepParticipantsAccounts.currency.name
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        forceValidations={this.props.mode === 'edit' ? false : true}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang={this.props.lang.currentLang.lang}
        translatedData={this.props.lang.translatedData}
        bankData={this.state.unqiueBankName}
        />
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson['par'].page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
      <p className="form-required-desc">{this.translations(pageTitle.descriptionText)}</p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentOtherAccount = undefined;
  if(props.match.params) {
    var {otherAccountId} = props.match.params;
    if(otherAccountId && state.currentProductGlsCashcon.data.otherAccounts.length > 0){
      state.currentProductGlsCashcon.data.otherAccounts.forEach(otherAccount => {
        if(otherAccount.id === otherAccountId) {
          currentOtherAccount = otherAccount;
        }
      });
    }
  }
  return {
    currentOtherAccount,
    mode: currentOtherAccount !== undefined ? 'edit' : '',
    lang: state.lang,
    cases:state.cases
  };
}

const mapDispatchToProps = dispatch => {
  return {
    setCurrentProductGlsCashCon: productGlsCashConData => {
      dispatch(setCurrentProductGlsCashCon(productGlsCashConData));
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CreateNewCashconOtherAccount);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/AddSweepInstruction/CreateNewCashconOtherAccount.js